import { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from 'react-router-dom';
import hizelus from '../assets/images/hizelus-logo1-dark.png'

import './Header.scss';

function NavBar() {
  const { t, i18n } = useTranslation(['translation', 'de']);
  const navigate = useNavigate();
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const getActiveKey = () => {
    const path = location.pathname;
    if (path === '/') return 'home';
    if (path === '/about-us') return 'about';
    if (path === '/services') return 'service';
    if (path === '/faqs') return 'faq';
    if (path === '/contact-us') return 'contact';
    return '';
  };

  const activeKey = getActiveKey();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'de' : 'en';
    i18n.changeLanguage(newLang);
  };

  return (
    <Container fluid className={`nav-bar-container ${scrolled ? 'nav-scrolled' : ''}`}>
      <Navbar bg="transparent" className='header-navbar' expand="lg">
        <div className="nav-brand-wrapper">
          <Navbar.Brand href="#" onClick={() => navigate('/')}>
            <img src={hizelus} className='img-fluid nav-logo' alt="Hizelus" />
          </Navbar.Brand>
        </div>
        <Navbar.Toggle aria-controls="navbarScroll" />
        <Navbar.Collapse id="navbarScroll">
          <div className="nav-spacer"></div>
          <div className="nav-links-center">
            <Nav navbarScroll>
              <Nav.Link
                className={activeKey === 'home' ? 'nav-active' : ''}
                onClick={() => navigate('/')}
              >
                {t('header.home')}
                {activeKey === 'home' && <span className="nav-indicator" />}
              </Nav.Link>
              <Nav.Link
                className={activeKey === 'about' ? 'nav-active' : ''}
                onClick={() => navigate('/about-us')}
              >
                {t('header.about')}
                {activeKey === 'about' && <span className="nav-indicator" />}
              </Nav.Link>
              <Nav.Link
                className={activeKey === 'service' ? 'nav-active' : ''}
                onClick={() => navigate('/services')}
              >
                {t('header.services')}
                {activeKey === 'service' && <span className="nav-indicator" />}
              </Nav.Link>
              <Nav.Link
                className={activeKey === 'faq' ? 'nav-active' : ''}
                onClick={() => navigate('/faqs')}
              >
                {t('header.faqs')}
                {activeKey === 'faq' && <span className="nav-indicator" />}
              </Nav.Link>
            </Nav>
          </div>
          <div className='header-actions'>
            <button className='lang-switch' onClick={toggleLanguage}>
              <span className={i18n.language === 'en' ? 'lang-active' : ''}>EN</span>
              <span className="lang-divider">/</span>
              <span className={i18n.language === 'de' ? 'lang-active' : ''}>DE</span>
            </button>
            <Button
              onClick={() => navigate('/contact-us')}
              className={`contact-btn ${activeKey === 'contact' ? 'contact-btn--active' : ''}`}
            >
              {t('header.contact')}
            </Button>
          </div>
        </Navbar.Collapse>
      </Navbar>
    </Container>
  );
}

export default NavBar;
